<template>
<div class="preview"
  ref="previewPdf"
  :style="scaleStyle">
  <template v-if="!isConsultationPlan">
    <section class="doc-paper"
      v-for="(section, sectionIndex) in sections"
      :index="sectionIndex"
      :key="sectionIndex">
      <component v-for="(group, index) in section"
        :ref="'component_'+index"
        :index="index"
        :key="group.itemId + '-' + index"
        v-bind:is="getCardPreviewComponent(group.componentName)"
        v-bind:group="group"
        v-if="isDisplay(group)"
        v-bind:isConsultationPlan="isConsultationPlan">
      </component>
    </section>
</template>
<template v-else>
<section class="doc-paper">
  <component v-for="(group, index) in basicPlan.items"
    :ref="'component_'+index"
    :index="index"
    :key="group.itemId + '-' + index"
    v-bind:is="getCardPreviewComponent(group.componentName)"
    v-bind:group="group"
    v-bind:groupIndex="index"
    v-if="isDisplay(group)"
    v-bind:isConsultationPlan="isConsultationPlan"
    v-bind:isEditableComment="isEditableComment">
  </component>
</section>
</template>
  <!-- <Button @click="getRefs">getRefs</Button> -->
</div>
</template>

<script>
import cardIndex from '@/assets/card/index'
export default {
  props: ['basicPlan', 'previewScale', 'previewHeight', 'isConsultationPlan', 'isEditableComment'],
  data() {
    return {}
  },
  computed: {
    sections: function () {
      const sections = []
      let tempSection = []
      for (let i in this.basicPlan.items) {
        let item = this.basicPlan.items[i]
        tempSection.push(item)
        if (item.pageBreak === true) {
          sections.push(tempSection)
          tempSection = []
        }
      }
      if (tempSection) {
        sections.push(tempSection)
      }
      return sections
    },
    scaleStyle: function () {
      if (!this.previewScale) {
        return {}
      }
      let style = {
        'transform': 'scale(' + this.previewScale + ')',
        'transform-origin': 'top left',
      }
      if (this.previewHeight) {
        style['height'] = this.previewHeight * this.previewScale + 'px'
      }
      return style
    }
  },
  mounted: function () {},
  methods: {
    getRefs: function () {
      console.log(this.$refs)
    },
    getCardPreviewComponent: function (componentName, type) {
      return cardIndex[componentName].preview
    },
    isDisplay: function (group) {
      if (group.itemId !== 'company-profile') {
        return true
      }
      if (this.basicPlan.items[0].items[0].data.companyFormat === 'corporation') {
        return true
      }
      return false
    }
  }
}
</script>
<style>

</style>
